"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAuthWithError = exports.useAuth = exports.getMember = exports.Auth = void 0;
var _isomorphicUnfetch = _interopRequireDefault(require("isomorphic-unfetch"));
var _react = require("react");
var _universalCookie = _interopRequireDefault(require("universal-cookie"));
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ENDPOINT = '/ns-sd/frontservices/2.0/authentication/webvalidate';
var COOKIE = '.ASPXAUTH';
var STORAGE_KEY = 'veepeeMember';
var getMemberFromSession = function getMemberFromSession() {
  var _sessionStorage;
  var member = (_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.getItem(STORAGE_KEY);
  if (!member) return undefined;
  return JSON.parse(member);
};
var setMemberToSession = function setMemberToSession(member) {
  var _sessionStorage2;
  (_sessionStorage2 = sessionStorage) === null || _sessionStorage2 === void 0 || _sessionStorage2.setItem(STORAGE_KEY, JSON.stringify(member));
};
var getAuthCookie = function getAuthCookie(cookie) {
  var cookies = new _universalCookie["default"](cookie);
  return cookies.get(COOKIE);
};
var getHeaders = function getHeaders(cookie) {
  return {
    // headers are discarded on client side requests
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Cookie: "".concat(COOKIE, "=").concat(cookie)
  };
};
var getOptions = function getOptions(cookie) {
  var _ref = getMemberFromSession() || {},
    email = _ref.email,
    t = _ref.t;
  return {
    body: JSON.stringify({
      email: email,
      token: t
    }),
    credentials: 'same-origin',
    headers: getHeaders(cookie),
    method: 'POST'
  };
};
var fetchMember = function fetchMember(baseUrl, cookie) {
  return (0, _isomorphicUnfetch["default"])("".concat(baseUrl).concat(ENDPOINT), getOptions(cookie)).then(function (res) {
    (0, _utils.handleInvalidResponse)(res);
    return res.json();
  }).then(function (payload) {
    (0, _utils.handleInvalidPayload)(payload);
    return payload.member;
  });
};
var fetchMemberSSR = function fetchMemberSSR(ctx) {
  var _ctx$req = ctx.req,
    headers = _ctx$req.headers,
    socket = _ctx$req.socket;
  var protocol = socket.encrypted ? 'https' : 'http';
  var baseUrl = "".concat(protocol, "://").concat(headers.host);
  var cookie = getAuthCookie(headers.cookie);
  return fetchMember(baseUrl, cookie);
};
var getMember = exports.getMember = function getMember() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    ctx = _ref2.ctx,
    refetch = _ref2.refetch,
    _ref2$baseUrl = _ref2.baseUrl,
    baseUrl = _ref2$baseUrl === void 0 ? '' : _ref2$baseUrl;
  if (ctx && ctx.req) return fetchMemberSSR(ctx);
  var member = getMemberFromSession();
  if (!refetch && member) return Promise.resolve(member);
  return fetchMember(baseUrl).then(function (res) {
    setMemberToSession(res);
    return res;
  });
};
var Context = /*#__PURE__*/(0, _react.createContext)();
var Auth = exports.Auth = function Auth(_ref3) {
  var children = _ref3.children,
    externalMember = _ref3.member,
    baseUrl = _ref3.baseUrl;
  var _useState = (0, _react.useState)(externalMember),
    _useState2 = _slicedToArray(_useState, 2),
    member = _useState2[0],
    setMember = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  (0, _react.useEffect)(function () {
    if (!externalMember) getMember({
      baseUrl: baseUrl
    }).then(setMember)["catch"](function (err) {
      setError(err);
      throw err;
    });
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Context.Provider, {
    value: {
      member: member,
      error: error
    },
    children: children
  });
};
var useAuth = exports.useAuth = function useAuth() {
  return (0, _react.useContext)(Context).member;
};
var useAuthWithError = exports.useAuthWithError = function useAuthWithError() {
  return (0, _react.useContext)(Context);
};